import { render, staticRenderFns } from "./NcrDefectSubmission.vue?vue&type=template&id=2799ff5e&"
import script from "./NcrDefectSubmission.vue?vue&type=script&lang=js&"
export * from "./NcrDefectSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports